import { wizardProps } from '@xengage/gw-portals-wizard-react';
import { FNOLPARepairFacilityMapPage } from 'gwce-capability-fnol-pa-react-ext';
import React from 'react';

function FNOLRepairFacilityMapPage(props) {
    return <FNOLPARepairFacilityMapPage {...props} />;
}

FNOLRepairFacilityMapPage.propTypes = wizardProps;
export default FNOLRepairFacilityMapPage;
